import { css } from 'styled-components/macro';

export const animations = css`
    @keyframes fade-in {
        from { opacity: 0 }
        to { opacity: 1 }
    }
`